import { render, staticRenderFns } from "./PointsMall.vue?vue&type=template&id=42212234&scoped=true"
import script from "./PointsMall.vue?vue&type=script&lang=js"
export * from "./PointsMall.vue?vue&type=script&lang=js"
import style0 from "./PointsMall.vue?vue&type=style&index=0&id=42212234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42212234",
  null
  
)

export default component.exports